import { Component, OnInit, Inject, Optional } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl, AsyncValidatorFn, ValidationErrors, FormArray, FormControl } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from '../../models/user.model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CountryISO } from 'ngx-intl-tel-input';
import { ToasterService } from '../../../core/toaster/toaster.service';
import { TranslocoService } from '@ngneat/transloco';
import { TILES } from '../../../reference/constants/reference.constants';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-user-add-dailog',
  templateUrl: './user-add-dailog.component.html',
  styleUrls: ['./user-add-dailog.component.scss'],
})
export class UserAddDailogComponent implements OnInit {
  userForm!: FormGroup;
  departmentList!: string[];
  selectedCountry: CountryISO = CountryISO.Kuwait;
  onlyCountries: CountryISO[] = [CountryISO.Kuwait, CountryISO.India, CountryISO.UnitedStates];
  isUpdate: boolean = true;
  tiles = TILES;
  dataSource!: MatTableDataSource<any>;
  selectedUserRoles!: string[];
  selectedRegions: any[] = [];
  selectedOrgs: any[] = [];
  primaryRegionId: number | null = null;
  selectedRegionId: number | null = null; // Track currently selected region
  userRegions: any[] = [];
  userOrganisations: any[] = [];
  userOrganisationsMap: { [regionId: number]: any[] } = {};
  displayedColumns: string[] = [
    'title',
    'admin',
    'edit',
    'view',
    'delete',
    'reviewer'

  ];
  regions = [
    { id: 1, name: 'KWT', selected: false, PrimaryRegion: false },
    { id: 2, name: 'KSA', selected: false, PrimaryRegion: false },
  ];
  regionOrganisations: { [key: number]: { id: number; name: string; selected: boolean }[] } = {
    1: [
      { id: 1, name: 'ALP', selected: false },
      { id: 2, name: 'S2', selected: false },
      { id: 3, name: 'MRE', selected: false }
    ],
    2: [
      { id: 1, name: 'XYZ', selected: false },
      { id: 2, name: 'ABC', selected: false }
    ]
  };
  private dataLoaded = {
    regions: false,
    organisations: false
  };

  constructor(public dialogRef: MatDialogRef<UserAddDailogComponent>,
    private fb: FormBuilder,
    private userService: UserService,
    private toasterService: ToasterService,
    private translocoService: TranslocoService,
    @Optional() @Inject(MAT_DIALOG_DATA) public user: User) {

  }

  ngOnInit() {
    this.loadRegion();
    this.loadOrganisations();
    this.userForm = this.fb.group({
      id: [null],
      firstName: [null, [Validators.required]],
      arabicName: [null, [Validators.required]],
      userName: [null],
      email: [null, {
        validators: [Validators.required],
        asyncValidators: [this.usernameValidator()],
        updateOn: 'blur'
      }],
      phoneNumber: [null],
      designation: [null, [Validators.required]],
      departmentName: [null, [Validators.required]],
      gender: [null, [Validators.required]],
      active: [true, [Validators.required]],
      tiles: this.fb.array([]),
      regions: this.fb.array([], Validators.required),
      organisations: this.fb.array([]),
    });
    this.loadRegionsForm();
    // Initialize tiles FormArray (works for both Add and Edit)
    const formArray = this.fb.array(
      this.tiles.map(tile => {
        const userTile = this.user?.tiles?.find((t: any) => t.tileId === tile.id);
        return this.fb.group({
          tileId: [tile.id],
          title: [tile.title],
          admin: [null],
          edit: [null],
          view: [null],
          delete: [null],
          reviewer: [null]
        });
      })
    );

    this.userForm.setControl('tiles', formArray);
    this.departmentList = ['IT', 'Maintenance', 'Sales', 'HR', 'Quality', 'Finance'];

    this.dataSource = new MatTableDataSource(
      this.tiles.map(tile => ({
        ...tile,
        admin: false,
        edit: false,
        view: false,
        delete: false,
        reviewer: false,
      }))
    );
    if (!this.user) {
      this.userForm.addControl('permissions', this.fb.array(
        this.tiles.map(tile => this.fb.group({
          tileId: tile.id,
          module: tile.title,
          admin: [false],
          edit: [false],
          view: [false],
          delete: [false],
          reviewer: [false]
        }))
      ));
    }

    if (this.user) {
      this.getRoles(this.user.id);
      this.userForm.patchValue({
        id: this.user.id,
        userName: this.user.userName,
        email: this.user.email,
        firstName: this.user.firstName,
        arabicName: this.user.arabicName,
        gender: this.user.gender,
        designation: this.user.designation,
        departmentName: this.user.departmentName,
        phoneNumber: this.user.phoneNumber,
        active: this.user.active,
      });

      // if (this.selectedUserRoles.includes('SysAdmin')) {
      //   const formArray = this.fb.array(
      //     this.tiles.map(tile => {
      //       const userTile = this.user.tiles?.find((t: any) => t.tileId === tile.id);

      //       return this.fb.group({
      //         tileId: [tile.id],
      //         title: [tile.title],
      //         admin: [true],
      //         edit: [true],
      //         view: [true],
      //         delete: [true],
      //       });
      //     })
      //   );
      // }
      // else {
      //   const formArray = this.fb.array(
      //     this.tiles.map(tile => {
      //       const userTile = this.user.tiles?.find((t: any) => t.tileId === tile.id);

      //       return this.fb.group({
      //         tileId: [tile.id],
      //         title: [tile.title],
      //         admin: [userTile?.isAdmin ? true : false],
      //         edit: [userTile?.canEdit ? true : false],
      //         view: [userTile?.canView ? true : false],
      //         delete: [userTile?.canDelete ? true : false],
      //       });
      //     })
      //   );
      // }
      // this.userForm.setControl('permissions', formArray);

      // this.userForm.setControl('tiles', formArray);


      // Handle phone number formatting
      if (this.user.phoneNumber) {
        const phone = this.user.phoneNumber;

        let dialCode = "";
        let nationalNumber = "";
        let countryCode = "";

        if (/^\+965\d{7,8}$/.test(phone)) {
          // Kuwait (8 digits)
          const match = phone.match(/^\+(965)(\d{7,8})$/);
          dialCode = `+${match![1]}`;
          nationalNumber = match![2];
          countryCode = "KW";

        } else if (/^\+91\d{10}$/.test(phone)) {
          // India (10 digits, remove leading 0 if present)
          const match = phone.match(/^\+(91)(0?\d{10})$/);
          dialCode = `+${match![1]}`;
          nationalNumber = match![2].replace(/^0+/, "");
          countryCode = "IN";

        } else if (/^\+1\d{10}$/.test(phone)) {
          // USA (10 digits)
          const match = phone.match(/^\+(1)(\d{10})$/);
          dialCode = `+${match![1]}`;
          nationalNumber = match![2];
          countryCode = "US";
        }

        if (dialCode) {
          this.userForm.patchValue({
            phoneNumber: {
              number: nationalNumber,
              internationalNumber: `${dialCode} ${nationalNumber}`,
              nationalNumber: nationalNumber,
              e164Number: this.user.phoneNumber,
              countryCode: countryCode,
              dialCode: dialCode
            }
          });

          this.selectedCountry = countryCode as any;
        }
      }
    }


    if (this.userForm) {
      Object.keys(this.userForm.controls).forEach(controlName => {
        const control = this.userForm.get(controlName);
        if (control) {
          if (this.id) {
            if (controlName !== 'phoneNumber' && controlName !== 'tiles' && controlName !== 'active') {
              control.disable();
            }
          } else {
            control.enable();
          }
        }
      });
    }


    const emailControl = this.userForm.get('email');
    if (emailControl) {
      emailControl.valueChanges.subscribe(v => {
        this.userForm.patchValue({
          userName: v
        });
      });
    }
  }

  checkValidation() {
    let user = this.userForm.value as User;
    user.phoneNumber = this.userForm.value.phoneNumber.internationalNumber.replace(/\s/g, "");
    let id = this.userForm.get('id')?.value;
    if (id == null) {
      this.isUpdate = false;
    }
    let number = user.phoneNumber.substring(1);
    this.userService.checkNumExists(number, id, this.isUpdate).subscribe(res => {
      if (!res && user.phoneNumber != null && user.phoneNumber != "") {
        this.save();
      } else {
        this.toasterService.error(
          this.translocoService.translateObject(
            'layout.messages.numberExists'
          )
        );
      }
    });
  }

  save() {
    this.userForm.markAllAsTouched();
    this.userForm.updateValueAndValidity();

    // const tilesControl = this.userForm.get('tiles');
    // if (tilesControl?.invalid) {
    //   this.toasterService.error("Please select at least one permission for any module.");
    //   return;
    // }
    if (!this.isAnyRegionSelected()) {
      this.toasterService.error("Please select at least one region.");

      return;
    }
    if (!this.isAnyprimarySelected()) {
      this.toasterService.error("Please select at least one region as default.");
      return;
    }
    // if (!this.isAnyOrganisationSelected()) {
    //   this.toasterService.error("Please select at least one organisation for the selected region(s).");
    //   return;
    // }
    if (!this.areOrganisationsValid()) {
      this.toasterService.error("Each selected region must have at least one organisation selected.");
      return;
    }
    if (this.userForm.valid) {
      const formValue = this.userForm.getRawValue();
      if(this.userForm.getRawValue().phoneNumber == null){
        this.toasterService.warning("Please enter mobile number");
      }

      const user: User = {
        ...formValue,
        id: this.userForm.get('id')?.value,
        phoneNumber: formValue.phoneNumber?.e164Number || '',
        departmentName: this.userForm.controls['departmentName'].value,
        email: this.userForm.controls['email'].value,
        tiles: (
          !this.user ? formValue.permissions : formValue.tiles
        ).filter((p: any) =>
          p.admin || p.edit || p.view || p.delete || p.reviewer
        ).map((p: any) => ({
          tileId: p.tileId,
          module: p.title, // use title from form
          isAdmin: p.admin,
          canEdit: p.edit,
          canView: p.view,
          canDelete: p.delete,
          isReviewer: p.reviewer,
        })),
        regions: this.selectedRegions,
        organisations: this.selectedOrgs
      };

      let cleanPhone = user.phoneNumber?.replace(/\s/g, "") || "";
      let id = this.userForm.get('id')?.value;
      this.isUpdate = id != null;

      let numberToCheck = cleanPhone.startsWith("+")
        ? cleanPhone.substring(1)
        : cleanPhone;

      if (this.isUpdate) {
        // 🔹 Directly call save for update
        this.userService.save(user).subscribe(response => {
          if (response) {
            this.toasterService.success("User details updated successfully");
            this.dialogRef.close({ success: response });
          }
        });
      } else {
        // 🔹 Check number only when creating
        this.userService.checkNumExists(numberToCheck, id, this.isUpdate).subscribe(res => {
          if (!res && cleanPhone !== "") {
            this.userService.save(user).subscribe(response => {
              if (response) {
                this.toasterService.success("User details saved successfully");
                this.dialogRef.close({ success: response });
              }
            });
          } else {
            this.toasterService.error(
              this.translocoService.translateObject('layout.messages.numberExists')
            );
          }
        });
      }
    }
  }


  onClose(): void {
    this.dialogRef.close();
  }
  public get userName(): AbstractControl | null {
    return this.userForm.get('userName');
  }
  public get id(): string {
    return this.userForm.get('id')?.value;
  }
  usernameValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (this.id) {
        return of({});
      }

      return this.userService.checkUsernameExists(control.value).pipe(
        map(res => {
          // if res is true, username exists, return true
          return res ? { usernameExists: true } : null;
          // NB: Return null if there is no error
        })
      );
    };
  }

  validate(control: string) {
    return this.userForm.get(control);
  }

  get permissions() {
    return this.userForm.get('permissions') as FormArray;
  }

  get tilesFormArray(): FormArray {
    return this.userForm.get('tiles') as FormArray;
  }

  onAdminChange(index: number, checked: boolean) {
    const group = this.permissions.at(index) as FormGroup;

    const controls = ['edit', 'view', 'delete'];

    if (checked) {
      // Select all permissions
      controls.forEach(p => {
        group.get(p)?.setValue(true);
        group.get(p)?.disable({ emitEvent: false }); // make readonly
      });
    } else {
      // Deselect all permissions or leave previous values as needed
      controls.forEach(p => {
        group.get(p)?.setValue(false);
        group.get(p)?.enable({ emitEvent: false }); // make editable again
      });
    }
  }

  onAdminChangeEdit(index: number, checked: boolean) {
    const group = (this.userForm.get('tiles') as FormArray).at(index) as FormGroup;

    if (checked) {
      // If Admin is checked → enable all, then disable them
      group.get('edit')?.setValue(true);
      group.get('view')?.setValue(true);
      group.get('delete')?.setValue(true);
      group.get('reviewer')?.setValue(true);


      group.get('edit')?.disable();
      group.get('view')?.disable();
      group.get('delete')?.disable();
      group.get('reviewer')?.disable();

    } else {
      // If Admin is unchecked → reset and re-enable them
      group.get('edit')?.setValue(false);
      group.get('view')?.setValue(false);
      group.get('delete')?.setValue(false);
      group.get('reviewer')?.setValue(false);


      group.get('edit')?.enable();
      group.get('view')?.enable();
      group.get('delete')?.enable();
      group.get('reviewer')?.enable();

    }
  }

  getPermissionControl(i: number, permission: 'admin' | 'edit' | 'view' | 'delete' | 'reviewer'): FormControl {
    return this.permissions.at(i).get(permission) as FormControl;
  }

  getPermissionControlEdit(index: number, controlName: string): FormControl {
    return (this.userForm.get('tiles') as FormArray)
      .at(index)
      .get(controlName) as FormControl;
  }

  getPermissionControlDynamic(index: number, controlName: string): FormControl {

    const formArray = this.user ? this.userForm.get('tiles') as FormArray : this.permissions;
    return formArray.at(index).get(controlName) as FormControl;
  }

  onAdminChangeDynamic(index: number, checked: boolean) {
    const formArray = this.user ? this.userForm.get('tiles') as FormArray : this.permissions; const group = formArray.at(index) as FormGroup;
    const controls = ['edit', 'view', 'delete', 'reviewer'];
    controls.forEach(p => { group.get(p)?.setValue(checked); checked ? group.get(p)?.disable({ emitEvent: false }) : group.get(p)?.enable({ emitEvent: false }); });
  }

  onEditChangeDynamic(index: number, checked: boolean) {
    const formArray = this.user ? this.userForm.get('tiles') as FormArray : this.permissions; const group = formArray.at(index) as FormGroup;
    const controls = ['view'];
    controls.forEach(p => { group.get(p)?.setValue(checked); checked ? group.get(p)?.disable({ emitEvent: false }) : group.get(p)?.enable({ emitEvent: false }); });
  }

  onDeleteChangeDynamic(index: number, checked: boolean) {
    const formArray = this.user ? this.userForm.get('tiles') as FormArray : this.permissions; const group = formArray.at(index) as FormGroup;
    const controls = ['view'];
    controls.forEach(p => { group.get(p)?.setValue(checked); checked ? group.get(p)?.disable({ emitEvent: false }) : group.get(p)?.enable({ emitEvent: false }); });
  }

  onReviewerChangeDynamic(index: number, checked: boolean) {
    const formArray = this.user ? this.userForm.get('tiles') as FormArray : this.permissions; const group = formArray.at(index) as FormGroup;
    const controls = ['view'];
    controls.forEach(p => { group.get(p)?.setValue(checked); checked ? group.get(p)?.disable({ emitEvent: false }) : group.get(p)?.enable({ emitEvent: false }); });
  }

  getRoles(userId: string) {
    this.userService.getRoles(userId).subscribe(response => {
      this.selectedUserRoles = response;

      // const formArray = this.fb.array(
      //   this.tiles.map(tile => {
      //     const userTile = this.user?.tiles?.find((t: any) => t.tileId === tile.id);
      //     return this.fb.group({
      //       tileId: [tile.id],
      //       title: [tile.title],
      //       admin: [userTile?.isAdmin ?? false],
      //       edit: [userTile?.canEdit ?? false],
      //       view: [userTile?.canView ?? false],
      //       delete: [userTile?.canDelete ?? false],
      //     });
      //   })
      // );

      //   this.userForm.setControl('tiles', formArray);
      if (this.selectedUserRoles.includes('SysAdmin')) {
        const formArray = this.fb.array(
          this.tiles.map(tile => {
            return this.fb.group({
              tileId: [tile.id],
              title: [tile.title],
              admin: [{ value: true, disabled: true }],
              edit: [{ value: true, disabled: true }],
              view: [{ value: true, disabled: true }],
              delete: [{ value: true, disabled: true }],
              reviewer: [{ value: true, disabled: true }],

            });
          })
        );
        this.userForm.setControl('permissions', formArray);
        this.userForm.setControl('tiles', formArray);

      }
      else {
        const formArray = this.fb.array(
          this.tiles.map(tile => {
            const userTile = this.user.tiles?.find((t: any) => t.tileId === tile.id);
            const isAdmin = userTile?.isAdmin ?? false;

            return this.fb.group({
              tileId: [tile.id],
              title: [tile.title],
              admin: [isAdmin],
              edit: isAdmin
                ? this.fb.control({ value: true, disabled: true })
                : this.fb.control(userTile?.canEdit ?? false),
              view: isAdmin
                ? this.fb.control({ value: true, disabled: true })
                : this.fb.control(userTile?.canView ?? false),
              delete: isAdmin
                ? this.fb.control({ value: true, disabled: true })
                : this.fb.control(userTile?.canDelete ?? false),
              reviewer: isAdmin
                ? this.fb.control({ value: true, disabled: true })
                : this.fb.control(userTile?.isReviewer ?? false),
            });
          })
        );
        this.userForm.setControl('permissions', formArray);
        this.userForm.setControl('tiles', formArray);
      }

    });
  }



  isAnyprimarySelected(): boolean {
    return this.selectedRegions.some(r => r.primaryRegion);
  }
  get regionsFormArray(): FormArray {
    return this.userForm.get('regions') as FormArray;
  }
  loadRegionsForm() {
    // ✅ Do NOT push anything into form
    const formArray = this.userForm.get('regions') as FormArray;
    formArray.clear();

    // Just render UI list (keep data in this.regions)
    this.userRegions.forEach(region => {
      region.selected = false;
      region.PrimaryRegion = false;
    });

    // Keep formArray empty until user selects something
  }





  isRegionSelected(region: any): boolean {
    return this.selectedRegions.some(r => r.id === region.id);
  }

  isAnyRegionSelected(): boolean {
    return this.selectedRegions.length > 0;
  }

  isAnyPrimarySelected(): boolean {
    return this.selectedRegions.some(r => r.primaryRegion);
  }

  isAnyRegionsOrgSelected(): boolean {
    return this.selectedRegions.some(r => r.primaryRegion);
  }

  isAnyOrganisationSelected(): boolean {
    // Check if any selected region has at least one selected organisation
    return Object.values(this.userOrganisationsMap).some((orgList: any[]) =>
      orgList.some(org => org.selected)
    );
  }

  areOrganisationsValid(): boolean {
    return this.selectedRegions.every(region =>
      this.userOrganisationsMap[region.id]?.some(org => org.selected)
    );
  }

  loadRegion(): void {
    this.userService.getRegions().subscribe({
      next: (response) => {
        this.userRegions = response.map(r => ({ ...r, selected: false }));
        this.dataLoaded.regions = true;
        this.checkIfDataReady();
      },
      error: (err) => console.error('Error loading regions:', err)
    });
  }

  loadOrganisations(): void {
    this.userService.getOrganisations().subscribe({
      next: (response) => {
        this.userOrganisations = response;
        this.buildUserOrganisationsMap();
        this.dataLoaded.organisations = true;
        this.checkIfDataReady();
      },
      error: (err) => console.error('Error loading organisations:', err)
    });
  }

  private checkIfDataReady(): void {
    if (this.dataLoaded.regions && this.dataLoaded.organisations && this.user) {
      this.patchUserRegionOrganisationSelections();
    }
  }

  // private patchUserRegionOrganisationSelections(): void {
  //   // ✅ Preselect regions
  //   this.user.regions.forEach((region: any) => {
  //     const match = this.userRegions.find(r => r.id === region.region);
  //     if (match) {
  //       match.selected = true;
  //       // Add to selectedRegions for saving
  //       if (!this.selectedRegions.find(r => r.id === match.id)) {
  //         this.selectedRegions.push({
  //           id: match.id,
  //           name: match.region || match.name,
  //           primaryRegion: region.primaryRegion
  //         });
  //       }
  //     }

  //     // Set default region
  //     if (region.primaryRegion) {
  //       this.primaryRegionId = region.region;
  //     }
  //   });

  //   // ✅ Preselect organisations
  //   this.user.organisations.forEach((org: any) => {
  //     const regionOrgs = this.userOrganisationsMap[org.regionId];
  //     if (regionOrgs) {
  //       const matchOrg = regionOrgs.find(o => o.id === org.orgId);
  //       if (matchOrg) {
  //         matchOrg.selected = org.isActive;
  //       }
  //     }

  //     // Add to selectedOrgs array
  //     if (org.isActive) {
  //       this.selectedOrgs.push({
  //         orgId: org.orgId,
  //         regionId: org.regionId,
  //         isActive: true
  //       });
  //     }
  //   });

  //   // ✅ Sync to form
  //   this.userForm.patchValue({
  //     regions: this.selectedRegions,
  //     organisations: this.selectedOrgs
  //   });

  //   // Force refresh for Angular to show selections
  //   this.userRegions = [...this.userRegions];
  // }

  private patchUserRegionOrganisationSelections(): void {
    const regionsArray = this.userForm.get('regions') as FormArray;
    const orgsArray = this.userForm.get('organisations') as FormArray;

    regionsArray.clear();
    orgsArray.clear();

    this.selectedRegions = [];
    this.selectedOrgs = [];

    // ✅ Preselect regions
    this.user.regions.forEach((region: any) => {
      const match = this.userRegions.find(r => r.id === region.region);
      if (match) {
        match.selected = true;

        const regionGroup = this.fb.group({
          id: [match.id],
          name: [match.region || match.name],
          primaryRegion: [region.primaryRegion],
          active: [true],
        });

        regionsArray.push(regionGroup);

        this.selectedRegions.push(regionGroup.value);

        // Set default region if primary
        if (region.primaryRegion) {
          this.primaryRegionId = match.id;
        }
      }
    });

    // ✅ Preselect organisations
    this.user.organisations.forEach((org: any) => {
      const regionOrgs = this.userOrganisationsMap[org.regionId];
      if (regionOrgs) {
        const matchOrg = regionOrgs.find(o => o.id === org.orgId);
        if (matchOrg) {
          matchOrg.selected = org.isActive;
        }
      }

      if (org.isActive) {
        const orgGroup = this.fb.group({
          id: [org.id],
          userId: [org.userId],
          regionId: [org.regionId],
          orgId: [org.orgId],
          isActive: [org.isActive],
        });

        orgsArray.push(orgGroup);
        this.selectedOrgs.push(orgGroup.value);
      }
    });

    // ✅ Force refresh for UI
    this.userRegions = [...this.userRegions];
  }



  private buildUserOrganisationsMap(): void {
    this.userOrganisationsMap = {};
    this.userOrganisations.forEach(org => {
      if (!this.userOrganisationsMap[org.regionId]) {
        this.userOrganisationsMap[org.regionId] = [];
      }
      this.userOrganisationsMap[org.regionId].push({ ...org, selected: false });
    });
  }

  onRegionChange(region: any, event: any): void {
    region.selected = event.checked;

    const regionsArray = this.userForm.get('regions') as FormArray;
    const orgsArray = this.userForm.get('organisations') as FormArray;

    if (event.checked) {
      // ✅ Add region if selected and not already present
      if (!this.selectedRegions.find(r => r.id === region.id)) {
        const newRegion = {
          id: region.id,
          name: region.region,
          primaryRegion: false,
          active: true
        };
       
        this.selectedRegions.push(newRegion);
        regionsArray.push(this.fb.group(newRegion));
        this.onPrimaryChange(region.id)
      }
    } else {
      // ✅ Remove region if unchecked
      this.selectedRegions = this.selectedRegions.filter(r => r.id !== region.id);

      // Remove from FormArray
      const regionIndex = regionsArray.controls.findIndex(c => c.value.id === region.id);
      if (regionIndex !== -1) {
        regionsArray.removeAt(regionIndex);
      }

      // ✅ If this region was primary, clear it
      if (this.primaryRegionId === region.id) {
        this.primaryRegionId = null;
        this.selectedRegions = this.selectedRegions.map(r => ({
          ...r,
          primaryRegion: false
        }));
      }

      // ✅ Unselect and remove all orgs of this region
      if (this.userOrganisationsMap[region.id]) {
        this.userOrganisationsMap[region.id].forEach(org => (org.selected = false));
      }

      // Remove those orgs from selectedOrgs and organisations FormArray
      this.selectedOrgs = this.selectedOrgs.filter(o => o.regionId !== region.id);
      for (let i = orgsArray.length - 1; i >= 0; i--) {
        if (orgsArray.at(i).value.regionId === region.id) {
          orgsArray.removeAt(i);
        }
      }
    }

    // ✅ Sync form
    this.userForm.patchValue({
      regions: this.selectedRegions,
      organisations: this.selectedOrgs
    });
  }

  onPrimaryChange(regionId: number): void {
    this.primaryRegionId = regionId;

    this.selectedRegions = this.selectedRegions.map(r => ({
      ...r,
      primaryRegion: r.id === regionId
    }));

    this.userForm.patchValue({ regions: this.selectedRegions });
  }

  onOrgChange(org: any, event: any, regionId: number): void {
    org.selected = event.checked;

    // Get the current list from the form
    //    this.selectedOrgs = this.userForm.get('organisations')?.value || [];

    if (event.checked) {
      // ✅ Add organisation if checked
      if (!this.selectedOrgs.find((o: any) => o.id === org.id && o.regionId === regionId)) {
        this.selectedOrgs.push({
          orgId: org.id,
          // name: org.organisationName || org.name,
          regionId: regionId
        });
      }
    } else {
      // ❌ Remove if unchecked
      const index = this.selectedOrgs.findIndex((o: any) => o.orgId === org.id && o.regionId === regionId);
      if (index > -1) this.selectedOrgs.splice(index, 1);
    }

    // ✅ Update the form control
    this.userForm.patchValue({ organisations: this.selectedOrgs });
  }

}



